import * as React from "react";

export interface ComboBoxItemContentProps {
    content: string;
    isHighlighted: boolean;
    highlightedString: string;
}

export function ComboBoxItemContent({
    isHighlighted,
    content,
    highlightedString,
}: ComboBoxItemContentProps): JSX.Element {
    const startHighlighting = content.toLowerCase().indexOf(highlightedString.toLowerCase());
    return isHighlighted && startHighlighting >= 0 ? (
        <Highlighted
            start={startHighlighting}
            content={content}
            isHighlighted={isHighlighted}
            highlightedString={highlightedString}
        />
    ) : (
        <>{content}</>
    );
}

const Highlighted = (props: { start: number } & ComboBoxItemContentProps): JSX.Element => {
    const { start, content, highlightedString } = props;
    const end = start + highlightedString.length;
    return (
        <span>
            {content.substring(0, start)}
            <strong>{content.substring(start, end)}</strong>
            {content.substring(end)}
        </span>
    );
};
